import type { EnvironmentId } from "@afar-research/contracts";

/**
 * Whether an AFAR Environment can hold a Thread Pull Request Collection at all.
 *
 * Read from the Environment's advertised capabilities rather than assumed, and asked the same way
 * by every surface that offers to link — the thread's panel, the dialog host, and the command
 * palette — so one of them cannot offer what another would refuse.
 */
export function supportsThreadPullRequests(
  configs: ReadonlyMap<
    EnvironmentId,
    { readonly environment: { readonly capabilities: Record<string, unknown> } }
  >,
  environmentId: EnvironmentId,
): boolean {
  return configs.get(environmentId)?.environment.capabilities.threadPullRequests !== undefined;
}
